import { Component, OnInit } from '@angular/core';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html'
})
export class SupportComponent implements OnInit {
  supportData: any;

  constructor(
    private commonBindingDataService: CommonBindingDataService,
  ) { }

  ngOnInit() {
    this.commonBindingDataService.getSupport().subscribe((result) => {
      this.supportData = result;
    }, (reason) => {
    });
  }
}

